import { render, staticRenderFns } from "./pcr-task-detail.vue?vue&type=template&id=da04d93a&scoped=true"
import script from "./pcr-task-detail.vue?vue&type=script&lang=js"
export * from "./pcr-task-detail.vue?vue&type=script&lang=js"
import style0 from "./pcr-task-detail.vue?vue&type=style&index=0&id=da04d93a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da04d93a",
  null
  
)

export default component.exports